export const featuredVideos = [
  {
    id: 'v1',
    title: '2026早春法式穿搭 | 一周通勤不重样',
    cover: 'https://readdy.ai/api/search-image?query=Fashion%20video%20thumbnail%20of%20a%20young%20Chinese%20woman%20wearing%20elegant%20French%20style%20spring%20outfit%20in%20a%20bright%20minimalist%20studio%20with%20soft%20natural%20lighting%2C%20warm%20beige%20and%20cream%20tones%2C%20clean%20composition%2C%20editorial%20fashion%20photography%20style%20with%20soft%20shadows%2C%20professional%20look&width=640&height=360&seq=mogu-featured-01&orientation=landscape',
    duration: '12:35',
    views: '238.5万',
    category: '穿搭教程',
    author: '时尚达人小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20fashion%20blogger%20portrait%20avatar%20with%20warm%20smile%20and%20elegant%20style%2C%20soft%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=mogu-avatar-01&orientation=squarish',
    slug: 'french-style-spring-outfit-2026'
  },
  {
    id: 'v2',
    title: '黄黑皮必看！春季口红试色全测评',
    cover: 'https://readdy.ai/api/search-image?query=Beauty%20video%20thumbnail%20showing%20lipstick%20swatches%20on%20arm%20with%20various%20warm%20tone%20colors%2C%20minimalist%20marble%20background%2C%20soft%20diffused%20lighting%2C%20clean%20and%20elegant%20cosmetics%20photography%20style%2C%20professional%20beauty%20content&width=640&height=360&seq=mogu-featured-02&orientation=landscape',
    duration: '08:22',
    views: '189.2万',
    category: '美妆测评',
    author: '美妆控CC',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20beauty%20influencer%20portrait%20avatar%20with%20flawless%20makeup%20and%20gentle%20expression%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background&width=80&height=80&seq=mogu-avatar-02&orientation=squarish',
    slug: 'spring-lipstick-review-2026'
  },
  {
    id: 'v3',
    title: '小众设计师品牌开箱 | 质感满分',
    cover: 'https://readdy.ai/api/search-image?query=Fashion%20unboxing%20video%20thumbnail%20with%20designer%20clothing%20items%20laid%20out%20on%20a%20minimalist%20white%20surface%2C%20warm%20natural%20light%20from%20window%2C%20aesthetic%20flat%20lay%20composition%2C%20elegant%20and%20clean%20visual%20style&width=640&height=360&seq=mogu-featured-03&orientation=landscape',
    duration: '15:48',
    views: '156.7万',
    category: '潮流单品',
    author: '买买买小仙女',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20fashion%20shopper%20portrait%20avatar%20with%20bright%20smile%20and%20trendy%20style%2C%20warm%20lighting%2C%20clean%20minimalist%20background&width=80&height=80&seq=mogu-avatar-03&orientation=squarish',
    slug: 'designer-brand-unboxing-2026'
  },
  {
    id: 'v4',
    title: '小个子穿搭秘籍 | 显高显瘦搭配公式',
    cover: 'https://readdy.ai/api/search-image?query=Petite%20woman%20fashion%20video%20thumbnail%20showing%20outfit%20combinations%20that%20create%20taller%20silhouette%2C%20bright%20airy%20studio%20with%20warm%20beige%20walls%2C%20clean%20composition%2C%20professional%20fashion%20photography&width=640&height=360&seq=mogu-featured-04&orientation=landscape',
    duration: '10:15',
    views: '312.8万',
    category: '穿搭教程',
    author: '一米五的时髦精',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20petite%20fashion%20creator%20portrait%20avatar%20with%20confident%20expression%2C%20stylish%20outfit%2C%20warm%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-04&orientation=squarish',
    slug: 'petite-dressing-tips-2026'
  },
  {
    id: 'v5',
    title: '2026春夏流行色趋势解读 | 必入单品',
    cover: 'https://readdy.ai/api/search-image?query=Fashion%20trend%20video%20thumbnail%20with%20color%20palette%20samples%20and%20clothing%20items%20in%20spring%20summer%20hues%2C%20minimalist%20white%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20style&width=640&height=360&seq=mogu-featured-05&orientation=landscape',
    duration: '09:40',
    views: '201.3万',
    category: '时尚趋势',
    author: '潮流播报员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20trend%20analyst%20portrait%20avatar%20with%20fashionable%20glasses%20and%20modern%20style%2C%20professional%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-05&orientation=squarish',
    slug: 'spring-summer-color-trend-2026'
  },
  {
    id: 'v6',
    title: '学生党平价护肤routine | 百元搞定',
    cover: 'https://readdy.ai/api/search-image?query=Skincare%20routine%20video%20thumbnail%20with%20affordable%20beauty%20products%20arranged%20on%20a%20clean%20white%20vanity%2C%20soft%20morning%20light%2C%20fresh%20and%20clean%20aesthetic%2C%20beauty%20content%20style&width=640&height=360&seq=mogu-featured-06&orientation=landscape',
    duration: '11:20',
    views: '275.4万',
    category: '美妆测评',
    author: '学生党小可爱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20student%20portrait%20avatar%20with%20fresh%20natural%20look%20and%20bright%20smile%2C%20soft%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-06&orientation=squarish',
    slug: 'student-skincare-routine-2026'
  },
];

export const categories = [
  { id: 'cat1', name: '穿搭教程', icon: 'ri-t-shirt-line', slug: 'fashion-tips', count: 1280 },
  { id: 'cat2', name: '美妆测评', icon: 'ri-palette-line', slug: 'beauty-review', count: 956 },
  { id: 'cat3', name: '潮流单品', icon: 'ri-shopping-bag-3-line', slug: 'trending-items', count: 843 },
  { id: 'cat4', name: '发型灵感', icon: 'ri-scissors-line', slug: 'hairstyle-inspo', count: 632 },
  { id: 'cat5', name: '包包开箱', icon: 'ri-handbag-line', slug: 'bag-unboxing', count: 517 },
  { id: 'cat6', name: '配饰精选', icon: 'ri-vip-diamond-line', slug: 'accessories', count: 428 },
  { id: 'cat7', name: '护肤干货', icon: 'ri-drop-line', slug: 'skincare-tips', count: 391 },
  { id: 'cat8', name: '时尚趋势', icon: 'ri-fire-line', slug: 'fashion-trends', count: 356 },
];

export const trendingTopics = [
  { id: 't1', title: '#早春穿搭', count: '86.5万' },
  { id: 't2', title: '#显瘦搭配', count: '72.3万' },
  { id: 't3', title: '#通勤穿搭', count: '68.9万' },
  { id: 't4', title: '#口红推荐', count: '55.7万' },
  { id: 't5', title: '#小众包包', count: '49.1万' },
  { id: 't6', title: '#春季护肤', count: '43.2万' },
  { id: 't7', title: '#国货之光', count: '38.6万' },
  { id: 't8', title: '#发型教程', count: '35.4万' },
];

export const stats = [
  { id: 's1', value: '5000万+', label: '月活跃用户' },
  { id: 's2', value: '100万+', label: '优质视频内容' },
  { id: 's3', value: '10万+', label: '入驻时尚达人' },
  { id: 's4', value: '98%', label: '用户好评率' },
];

export const faqItems = [
  {
    id: 'faq1',
    question: 'mogu视频是什么平台？',
    answer: 'mogu视频是蘑菇街旗下的时尚购物短视频平台，专注于穿搭教程、美妆测评、潮流单品推荐等内容。用户可以在观看视频的同时直接购买视频中展示的商品，实现边看边买的沉浸式购物体验。'
  },
  {
    id: 'faq2',
    question: '如何在mogu视频上购物？',
    answer: '在观看视频时，点击视频下方的商品链接即可查看详细信息和价格。您可以直接在mogu视频App内完成下单购买，享受便捷的一站式视频购物体验。支持多种支付方式，安全可靠。'
  },
  {
    id: 'faq3',
    question: 'mogu视频的内容质量如何保证？',
    answer: '我们拥有严格的内容审核机制和达人认证体系。所有入驻的时尚达人都经过专业筛选和培训，确保为用户提供高质量、有价值的时尚内容。同时，平台设有用户评价和举报机制，持续优化内容生态。'
  },
  {
    id: 'faq4',
    question: '如何在mogu视频上成为创作者？',
    answer: '您可以通过mogu视频App内的"创作者中心"申请入驻。我们欢迎热爱时尚、有创作热情的用户加入。通过审核后，即可开始发布视频内容，获得流量支持和商业变现机会。'
  },
  {
    id: 'faq5',
    question: 'mogu视频支持哪些设备？',
    answer: 'mogu视频支持iOS和Android移动设备，您可以在Apple App Store和各安卓应用商店搜索"mogu视频"下载官方App。同时，我们也提供Web网页版，方便您在电脑上浏览精彩内容。'
  },
  {
    id: 'faq6',
    question: '视频中的商品如何保证正品？',
    answer: 'mogu视频与蘑菇街共享供应链体系，所有在平台销售的商品均经过严格的正品审核。我们与品牌方和授权经销商直接合作，确保每一件商品都是正品，让您放心购买。'
  },
];

export const brandFeatures = [
  {
    id: 'bf1',
    icon: 'ri-play-circle-line',
    title: '沉浸式视频购物',
    description: '边看边买，视频即商品，打造全新购物体验'
  },
  {
    id: 'bf2',
    icon: 'ri-user-star-line',
    title: '时尚达人云集',
    description: '10万+认证时尚达人，分享真实穿搭和美妆心得'
  },
  {
    id: 'bf3',
    icon: 'ri-shield-check-line',
    title: '正品保障',
    description: '蘑菇街供应链背书，严格正品审核，购物无忧'
  },
  {
    id: 'bf4',
    icon: 'ri-line-chart-line',
    title: '潮流趋势一手掌握',
    description: '最新时尚资讯、流行趋势，第一时间推送给您'
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '小雨同学',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20with%20natural%20smile%2C%20casual%20style%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=mogu-testimonial-01&orientation=squarish',
    content: '自从用了mogu视频，我的穿搭品味提升了好几个level！跟着达人买从来没有踩过雷，质量都很棒，已经推荐给身边所有姐妹了！',
    rating: 5
  },
  {
    id: 't2',
    name: '职场新人Lily',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20professional%20woman%20portrait%20with%20confident%20smile%2C%20business%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-testimonial-02&orientation=squarish',
    content: '作为刚入职的新人，通勤穿搭真的头疼。mogu视频的通勤穿搭专题太实用了，衣服好看又不贵，同事都问我哪里买的！',
    rating: 5
  },
  {
    id: 't3',
    name: '美妆小白艾米',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20with%20fresh%20makeup%20look%20and%20gentle%20smile%2C%20soft%20lighting%2C%20clean%20minimalist%20background&width=80&height=80&seq=mogu-testimonial-03&orientation=squarish',
    content: '以前完全不会化妆，跟着mogu的美妆教程一步步学，现在已经能画出日常通勤妆了。视频讲解特别详细，新手也能学会！',
    rating: 5
  },
];

export const downloads = [
  { platform: 'iOS', icon: 'ri-apple-line', url: '#', label: 'App Store 下载' },
  { platform: 'Android', icon: 'ri-android-line', url: '#', label: '安卓应用商店下载' },
];